import React from 'react';
import CTAButton from './CTAButton';
import SecondaryButton from './SecondaryButton';

export default function Hero() {
  return (
    <section className="pt-16 pb-12 md:pt-28 md:pb-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center">
      <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 bg-emerald-50 text-emerald-700 rounded-full text-sm font-bold tracking-wide border border-emerald-100">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
        </span>
        Limited Time: Free Stock Promotion
      </div>
      
      <h1 className="text-4xl md:text-7xl font-black text-gray-900 tracking-tight leading-[1.1] mb-6">
        Claim Your Free Stocks <br />
        <span className="text-emerald-600 font-extrabold">Up to €100 Value</span>
      </h1>
      
      <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
        Join millions of investors on a <strong>fully regulated platform</strong>. 
        Sign up today, make a small deposit, and unlock your reward instantly.
      </p>
      
      <div className="flex flex-col items-center gap-6">
        {/* Dual Conversion Path */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full max-w-2xl">
          <CTAButton className="w-full sm:w-auto min-w-[220px]" text="Start Now" />
          <SecondaryButton 
            className="w-full sm:w-auto min-w-[220px] bg-white" 
            text="Guide Me on WhatsApp" 
          />
        </div>
        
        {/* Reassurance Line */}
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm font-medium text-gray-500">
          <span className="flex items-center gap-1">
            <span className="text-emerald-500">✓</span> Takes &lt; 5 mins
          </span>
          <span className="hidden sm:inline text-gray-300">•</span>
          <span className="flex items-center gap-1">
            <span className="text-emerald-500">✓</span> Deposit stays yours
          </span>
          <span className="hidden sm:inline text-gray-300">•</span>
          <span className="flex items-center gap-1">
            <span className="text-emerald-500">✓</span> Withdraw anytime
          </span>
        </div>
      </div>
    </section>
  );
}